export default "__VITE_ASSET__8ea1641e__"